/** Site slugs that use the physical locker bank UI on Book A Pickup. */
export const INVID_BANK_SITE_SLUGS = ["invid", "invid-pickup"];

export const isInvidBankSite = (slug) => {
  if (!slug) return false;
  return INVID_BANK_SITE_SLUGS.includes(String(slug).toLowerCase().trim());
};
